export const checkAnswer = (answer) => {
  if (!answer) return false;
  const month = new Date().getMonth();

  const monthMapping = {
    0: ['janvier', 'january'],
    1: ['fevrier', 'février', 'fvrier', 'february'],
    2: ['mars', 'march'],
    3: ['avril', 'april'],
    4: ['mai', 'may'],
    5: ['juin', 'june'],
    6: ['juillet', 'july'],
    7: ['aôut', 'août', 'aout', 'aot', 'aut', 'august'],
    8: ['septembre', 'september'],
    9: ['octobre', 'october'],
    10: ['novembre', 'november'],
    11: ['decembre', 'décembre', 'dcembre', 'december'],
  };

  return monthMapping[month].indexOf(answer.toLowerCase()) > -1;
};
